/**
 * @file config.js
 * @desc 客户列表
 * @author dingzhenyue
 */
// vip类型
export const vipTypeOptions = [
    {
        label: '至尊会员',
        value: '3'
    },
    {
        label: '尊享会员',
        value: '0'
    },
    {
        label: 'v卡',
        value: '1'
    },
    {
        label: '启航会员',
        value: '7'
    },
    {
        label: '精英会员',
        value: '8'
    }
];

export const codeTypeMap = {
    0: '尊享会员',
    1: 'V卡会员',
    3: '至尊会员',
    6: '体验会员',
    7: '启航会员',
    8: '精英会员'
};

// 归属地
export const cityTypeOptions = [
    {
        label: '一级城市',
        value: 'FIRST_CITY'
    },
    {
        label: '二级城市',
        value: 'SECOND_CITY'
    },
    {
        label: '其他城市',
        value: 'THIRD_CITY'
    }
];

export const cityTypeMap = {
    FIRST_CITY: '一线城市',
    SECOND_CITY: '二线城市',
    THIRD_CITY: '其他城市'
};
